export enum TransportType {
  walkingFloor = 'WalkingFloor',
  container = 'Container',
}
